// Akses perangkat: GPS & kompres foto (port core.js v1).

export interface Pos {
  lat: number;
  lng: number;
  acc: number;
}

export function getPosition(timeout = 12000): Promise<Pos | null> {
  return new Promise((resolve) => {
    if (!navigator.geolocation) return resolve(null);
    navigator.geolocation.getCurrentPosition(
      (p) => resolve({ lat: p.coords.latitude, lng: p.coords.longitude, acc: p.coords.accuracy }),
      () => resolve(null),
      { enableHighAccuracy: true, timeout, maximumAge: 30000 },
    );
  });
}

/** Kompres foto di HP sebelum dikirim (maks 1280 px, JPEG 0.7) → data URL. */
export function compressImage(file: File, max = 1280): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      const s = Math.min(1, max / Math.max(img.width, img.height));
      const c = document.createElement('canvas');
      c.width = Math.round(img.width * s);
      c.height = Math.round(img.height * s);
      c.getContext('2d')?.drawImage(img, 0, 0, c.width, c.height);
      URL.revokeObjectURL(url);
      resolve(c.toDataURL('image/jpeg', 0.7));
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Foto tidak bisa dibaca.'));
    };
    img.src = url;
  });
}

/**
 * Tautan telepon & WhatsApp dari nomor HP Indonesia. waLink = waLink() toko.js v1: nilai apa pun yang tidak kosong
 * menghasilkan tautan (tanpa angka → 'https://wa.me/'). Panduan memakai varian help.js v1 (kosong bila tanpa angka) —
 * lihat waLink di features/panduan/content.tsx; sengaja dibiarkan dua agar keluaran sama dengan v1 per layar.
 */
export const telLink = (p: unknown): string => (p ? `tel:${String(p).replace(/[^\d+]/g, '')}` : '');
export const waLink = (p: unknown): string => (p ? `https://wa.me/${String(p).replace(/\D/g, '').replace(/^0/, '62')}` : '');
